<template>
  <b-row
    class="main d-flex align-items-center justify-content-center px-5 w-100"
  >
    <p class="titleVerificationCode w-100">認証コード入力</p>
    <validation-observer ref="validationFormVerifyCode" @submit.prevent="onClickConfirmCode" class="w-100">
      <b-form class="submit-form">
        <validation-provider
          name="code"
          rules="codeRequired"
          mode="passive"
          v-slot="{ errors }"
        >
          <b-form-group id="confirmCode-group">
            <input-text-component
              id="confirmCode"
              v-model="form.confirmCode"
              :autofocus="true"
              :placeholder="`認証コード（6桁）`"
              :state="errors && errors.length ? true : false"
              :maxlength="6"
              @blur="cleanValidity('confirmCode')"
            />
            <span class="text-danger" v-for="(error, i) in errors" :key="i"
              >{{ errors[i] }}
            </span>
          </b-form-group>
        </validation-provider>

        <b-button type="submit" variant="info" class="btn-submit d-flex align-items-center justify-content-center">
          送信
          <span class="material-icons material-icons-outlined">
            keyboard_arrow_right
          </span>
        </b-button>
        <div class="forgot-password confirm-code pl-0">
          <a @click.prevent.stop="$emit('back-to-login')" class="cursor-pointer d-flex justify-content-center"
            >ログインに戻る</a
          >
        </div>
      </b-form>
    </validation-observer>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import FlashMessage from '../../common/flash-message.component'
import InputTextComponent from '../custom-components/InputTextComponent.vue'
extend('codeRequired', {
  ...required,
  message: '認証コードは必須です。'
})
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    InputTextComponent
  },
  data() {
    return {
      form: {
        confirmCode: ''
      }
    }
  },
  methods: {
    async onClickConfirmCode() {
      const isValid = await this.$refs.validationFormVerifyCode.validate()
      if (!isValid) {
        FlashMessage.getInstance().hideAllMessages()
        this.$emit('verify-code-correct')
        return
      }
      const { confirmCode } = this.form
      this.$emit('verify-code', confirmCode)
    },
    cleanValidity(id) {
      const input = document.getElementById(id)
      if (!input.checkValidity()) {
        input.setCustomValidity('')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  font-style: normal;
  font-weight: normal;
  @include responsive-fs(12);

  .forgot-password {
    margin-top: 20px;
    @include responsive-fs(12);
  }
  .forgot-password a {
    color: #155275;
  }
  .error-message {
    @include responsive-fs(12);
    line-height: 160%;
    color: #b41b3e;
  }
  .btn-submit {
    width: 100%;
  }
  .form-group input {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    color: #252422;
    @include responsive-fs(16);
    border: 1px solid #afafae;
    height: 38px;
  }
  .titleVerificationCode {
    font-weight: bold;
    @include responsive-fs(18);
    margin-bottom: 24px !important;
  }
}
</style>>



// WEBPACK FOOTER //
// src/components/user-info/VerifyCode.vue